import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueMeta from "vue-meta";
import "./assets/css/style.css";
import "./registerServiceWorker";
import router from "./router";
import VueToastr from "vue-toastr";
Vue.use(VueToastr, {
  defaultTimeout: 3000,
  defaultProgressBar: false,
  defaultProgressBarValue: 0,
  defaultType: "error",
  defaultPosition: "toast-top-center",
  defaultCloseOnHover: false,
  defaultStyle: { "background-color": "#7F5AF0" },
  defaultClassNames: ["animated", "fadeIn"],
});

import VueSmoothScroll from "vue2-smooth-scroll";
import './registerServiceWorker'
Vue.use(VueSmoothScroll, {
  duration: 800,
  updateHistory: false,
});

// import SmoothVuebar from "smooth-vuebar";
// Vue.use(SmoothVuebar, {
//     options: {
//         damping: 0.07,
//         thumbMinSize: 10,
//         renderByPixels: true,
//         alwaysShowTracks: false,
//         continuousScrolling: true,
//         delegateTo: null,
//     },
// });

Vue.config.productionTip = false;
Vue.use(VueMeta);
new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount("#app");
